<template>
    <div class="loginbg" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <div class="form-group">
                                <label for="exampleInputEmail1">Username</label>
                                <input type="text" name="username" class="form-control" id="exampleInputEmail1" placeholder="Enter Username">
                            </div>

                            <div class="form-group">
                                <label for="exampleInputPassword1">Password</label>
                                <input type="password" name="password" class="form-control" id="exampleInputPassword1" placeholder="Enter password">
                            </div>

                            <div class="form-check">
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <input type="checkbox">
                                    <span class="checkbox-placeholder"></span>
                                    Remember me
                                    <a href="#" >Not Registered? <!--Sign up?--></a>
                                </label>
                            </div> 
                            <div>
                                <button id="loginbtn" type="submit" class="btn btn-primary">Login</button>
                                <a href="#" >Forgot password?</a> 
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from 'vue';

    export default {
        name: 'Login',
        data() {
            return {
                username: "",
                password: "",
                login_err_msg: "",
                forgot_pass_url: "",
            }
        },
        created: function () {

        },
        beforeMount: function () {

        },
        mounted: function () {
            var self = this;
            $(".loginbg").show();
        },
        methods: {
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Login.vue